var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "a-input",
      class: {
        focused: _vm.isFocused,
        empty: _vm.inputTextLength === 0,
        "is-error": _vm.error,
      },
      style: { width: _vm.width },
    },
    [
      _vm.inputType === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputText,
                expression: "inputText",
              },
            ],
            attrs: { autocomplete: "off", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.inputText)
                ? _vm._i(_vm.inputText, null) > -1
                : _vm.inputText,
            },
            on: {
              focus: function ($event) {
                _vm.isFocused = true
              },
              blur: function ($event) {
                _vm.isFocused = false
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onEnter.apply(null, arguments)
              },
              change: function ($event) {
                var $$a = _vm.inputText,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.inputText = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.inputText = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.inputText = $$c
                }
              },
            },
          })
        : _vm.inputType === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputText,
                expression: "inputText",
              },
            ],
            attrs: { autocomplete: "off", type: "radio" },
            domProps: { checked: _vm._q(_vm.inputText, null) },
            on: {
              focus: function ($event) {
                _vm.isFocused = true
              },
              blur: function ($event) {
                _vm.isFocused = false
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onEnter.apply(null, arguments)
              },
              change: function ($event) {
                _vm.inputText = null
              },
            },
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputText,
                expression: "inputText",
              },
            ],
            attrs: { autocomplete: "off", type: _vm.inputType },
            domProps: { value: _vm.inputText },
            on: {
              focus: function ($event) {
                _vm.isFocused = true
              },
              blur: function ($event) {
                _vm.isFocused = false
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onEnter.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.inputText = $event.target.value
              },
            },
          }),
      _vm._v(" "),
      _c("label", [_vm._v(_vm._s(_vm.appliedLabel))]),
      _vm._v(" "),
      _vm.error || (_vm.type === "email" && !_vm.isValidEmail(_vm.inputText))
        ? _c("span", { staticClass: "error" }, [
            _vm._v(_vm._s(_vm.error || "Email is invalid")),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.required && !_vm.inputTextLength
        ? _c("span", { staticClass: "error" }, [
            _vm._v(_vm._s(_vm.requiredMessage)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }